import { CurrentUser } from 'models';
import axiosClient from './axios-client';

export const userApi = {
  getCurrentUser: async (): Promise<{ user: CurrentUser }> => {
    const response = await axiosClient.get('/user');
    return response.data ?? response;
  },
};
